import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { generateIdRoutePath } from '../../helpers';
import RallyInfoCard from '../../ui/RalliyInfoCard';
import { APP_ROUTES } from '../../app.config.vars/routes';
import Headline from '../../ui/Headline';
import Loader from '../../ui/Loader';
import { useTranslation } from 'react-i18next';
import { selectRallies, selectRalliesStatus } from '../../store/slices/ralliesPreview';
const RalliesList = ({ highlightedRallyId }) => {
    const { t } = useTranslation();
    const rallies = useSelector(selectRallies);
    const ralliesStatus = useSelector(selectRalliesStatus);
    const isLoading = ralliesStatus === 'idle' || ralliesStatus === 'loading';
    const renderContent = () => {
        if (isLoading) {
            return _jsx(Loader, {});
        }
        if (ralliesStatus === 'error') {
            return _jsx(Headline, { title: t('rallies_load_failed'), type: 'h3' });
        }
        if (!rallies.length) {
            return _jsx(Headline, { title: t('no_rallies_found'), type: 'h3' });
        }
        return rallies.map((rally) => (_jsx(NavLink, { to: generateIdRoutePath(APP_ROUTES.rallyPreview, rally.uuid), children: _jsx(RallyInfoCard, { themes: rally.themes, title: rally.publicTitle, geographicArea: rally.geographicArea, targetGroups: rally.targetGroups, hasLocation: rally.latitude !== null &&
                    rally.longitude !== null &&
                    rally.latitude !== 0 &&
                    rally.longitude !== 0, isHighlighted: highlightedRallyId === rally.uuid, rallyId: `rally-${rally.uuid}` }) }, rally.uuid)));
    };
    return (_jsx("div", { className: "rallies-list", "aria-busy": isLoading, children: renderContent() }));
};
export default RalliesList;
